"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.List = exports.ListContainer = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const style_1 = __importDefault(require("style"));
exports.ListContainer = styled_components_1.default.div `
  display: grid;
  row-gap: ${style_1.default.Layout.Spacing.Base};
`;
const List = ({ children, }) => {
    return ((0, jsx_runtime_1.jsx)(exports.ListContainer, { children: children }));
};
exports.List = List;
